<template>
  <table class="einvoice-summary-table">
    <tbody>
      <tr>
        <td class="summary-label">Cộng tiền hàng</td>
        <td class="summary-value">{{ formatCurrency(summary.totalBeforeTax) }}</td>
      </tr>
      <tr>
        <td class="summary-label">Cộng tiền thuế GTGT</td>
        <td class="summary-value">{{ formatCurrency(summary.totalVat) }}</td>
      </tr>
      <tr>
        <td class="summary-label">Tổng tiền chiết khấu</td>
        <td class="summary-value">{{ formatCurrency(summary.totalDiscount) }}</td>
      </tr>
      <tr class="summary-row-total" :class="{ 'summary-row-total--emphasized': emphasizeTotal }">
        <td class="summary-label">Tổng cộng tiền thanh toán</td>
        <td class="summary-value">{{ formatCurrency(summary.totalAmount) }}</td>
      </tr>
      <tr class="summary-row-text">
        <td class="summary-label">Tổng tiền thanh toán bằng chữ</td>
        <td class="summary-text" :class="amountInWordsClass">
          {{ resolvedAmountInWords }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  export default {
    name: 'EInvoiceSummaryTable',

    props: {
      summary: {
        type: Object,
        default: () => ({}),
      },
      emphasizeTotal: {
        type: Boolean,
        default: true,
      },
      amountInWordsText: {
        type: String,
        default: '',
      },
      amountInWordsClass: {
        type: [String, Array, Object],
        default: '',
      },
    },

    computed: {
      resolvedAmountInWords() {
        return this.amountInWordsText || this.summary.amountInWords || 'Không có dữ liệu'
      },
    },

    methods: {
      formatCurrency(value) {
        if (value == null) return '0'
        return new Intl.NumberFormat('vi-VN').format(Number(value) || 0)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .einvoice-summary-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    background: #fff;

    td {
      padding: 0.76rem 0.76rem;
      border: 1px solid #e3e8ee;
      background: #fff;
      color: #2f3542;
      line-height: 1.4;
      vertical-align: top;
    }
  }

  .summary-label {
    width: 41%;
    color: #556578;
    font-weight: 500;
  }

  .summary-value {
    text-align: right;
    font-variant-numeric: tabular-nums;
    font-weight: 600;
    color: #1f2937;
  }

  .summary-row-total td {
    border-top-color: #d4dde8;
    background: #f7fafc;
    font-weight: 700;
  }

  .summary-row-total--emphasized .summary-value {
    font-size: 1.06rem;
  }

  .summary-text {
    text-align: left;
    font-variant-numeric: normal;
    white-space: normal;
    font-weight: 500;
    color: #243041;
    line-height: 1.55;
  }

  .summary-row-text td {
    background: #fcfdff;
  }

  @media (max-width: 991.98px) {
    .einvoice-summary-table {
      td {
        padding: 0.66rem 0.6rem;
      }
    }

    .summary-label {
      width: 46%;
    }
  }
</style>
